// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import getExtensionPropsFromCombinedReducer from "@toolkit/Framework/Common/Utilities/redux/getExtensionPropsFromCombinedReducer";
import ProductSelectorReducer from "@store/Extensions/Store/Components/ProductSelector/ProductSelectorReducer";
import { combineReducers } from "redux";

const componentsReducer = combineReducers({
    ...getExtensionPropsFromCombinedReducer(reducers.components),
    productSelector: ProductSelectorReducer,
});

export default componentsReducer;
